import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class GetRecipientForm extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

        var request_data = JSON.stringify({
            "corridor": "bank",
            "locationId": "9100274",
            "session_id": "SESS_UWX2OXWDPURTHDVC4GERSTRXOWWGOIYL"
        }, null, 2);

        var response_data = JSON.stringify({
            "success": true,
            "data": [
                {
                    "fieldName": "ReceiverFirstName",
                    "fieldLabel": "Receiver First Name",
                    "required": true,
                    "type": "text",
                    "minLength": 1,
                    "maxLength": 50,
                    "regex": "^(?=.*[A-Za-z])[A-Za-z\\s'-]+$"
                },
                {
                    "fieldName": "BankBranchCode",
                    "fieldLabel": "IFSC Code",
                    "required": true,
                    "type": "text",
                    "regex": "^[A-Z]{4}0[A-Z0-9]{6}$"
                },
                {
                    "fieldName": "senderOccupation",
                    "fieldLabel": "Sender Occupation",
                    "required": true,
                    "type": "dropdown",
                    "data": [
                        {
                            "data": "73",
                            "value": "Construction industry"
                        }
                    ]
                }
            ]
        }, null, 2);
      
        var example1 = JSON.stringify({
            "fieldName": "BankBranchCode",
            "fieldLabel": "IFSC Code",
            "regex": "^[A-Z]{4}0[A-Z0-9]{6}$"
        }, null, 2)
        
        var example2 = JSON.stringify({
            "fieldName": "ReceiverFirstName",
            "regex": "^(?=.*[A-Za-z])[A-Za-z\\s'-]+$"
        }, null, 2)

        var example3 = JSON.stringify({
           "fieldName": "subPurposeOfPayment",
            "dynamicField": true,
            "dependsOn": "purposeOfPayment"
        }, null, 2)

        var example4 = JSON.stringify({
            "fieldName": "senderOccupation",
            "fieldLabel": "Sender Occupation",
            "required": true,
            "type": "dropdown",
            "data": [
                {
                "data": "73",
                "value": "Construction industry"
                }
            ]
         }, null, 2);

         var validationFieldExample = JSON.stringify({
            "fieldName": "ReceiverContactNumber",
            "fieldLabel": "Receiver Contact Number",
            "required": true,
            "dynamicField": false,
            "minLength": 1,
            "maxLength": 50,
            "type": "numeric",
            "isUpperCase": false,
            "hint": "",
            "info": "",
            "data": [],
            "validateRequired": true,
            "validateEndpoint": "validate-account"
        }, null, 2);
        
        var validationBankRequest = JSON.stringify({
            "session_id": "SESS_UWX2OXWDPURTHDVC4GERSTRXOWWGOIYL",
            "corridor": "bank",
            "location_value": "9100274",
            "account_number": "1234567890",
            "bank_branch_code": "HDFC0001234",
            "receiver_first_name": "John",
            "receiver_last_name": "Doe"
        }, null, 2);
        
        var validationMobileRequest = JSON.stringify({
            "session_id": "SESS_UWX2OXWDPURTHDVC4GERSTRXOWWGOIYL",
            "corridor": "mobile",
            "account_number": "971501234567",
            "receiver_first_name": "John",
            "receiver_last_name": "Doe"
        }, null, 2);
        
        var validationSuccessResponse = JSON.stringify({
            "success": true,
            "message": "Account is verified."
        }, null, 2);
        
        var validationFailureResponse = JSON.stringify({
            "success": false,
            "message": "Beneficiary validation failed"
        }, null, 2);

        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                        <article class="docs-article" id="section-1">
                        <h1 class="docs-heading">Get Recipient Form</h1>
                        <section class="docs-intro">

                            <p>
                            Returns the beneficiary fields required for the selected country, payout corridor, and payout institution.
                            </p>

                            <p>
                            Field requirements vary by destination country, payout provider, and compliance rules. All fields returned by this API must be rendered and validated dynamically. No beneficiary fields should be hardcoded.
                            </p>

                            <p>
                            Collect all required beneficiary fields before calling the Make Payment API.
                            </p>

                            </section>
                        </article>

                        <article class="docs-article" id="section-2">
                            <header class="docs-header">
                                <h1 class="docs-heading">
                                    Get Recipient Form Reference
                                </h1>
                                <section class="docs-intro row">
                                    <div class="col-lg-6 col-12">
                                    <p>
                                        This POST API returns the beneficiary form required for the selected payout route. The returned fields define the input controls, validation rules, dropdown values, and conditional fields that must be rendered dynamically.
                                    </p>
                                    <div class="alert alert-info mt-3">
                                        <b>When to Use</b>

                                        <p class="mb-0">
                                            Call this API after the user selects a payout institution and before collecting beneficiary information.
                                        </p>

                                    </div>
                                        <section class="docs-section row" id="item-2-3">
                                            <h2 class="section-heading">Api Params</h2>
                                            <div class="col-lg-6 col-12">
                                                <div class="attributes">
                                                <div class="attributes-head">
                                                    <h4>Request Attributes</h4>
                                                </div>

                                                <div class="attributes-contents">

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">corridor</span>
                                                    </div>

                                                    <p>
                                                        Type :
                                                        <span class="highlight"> String</span><br/>
                                                        Selected payout corridor.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">locationId</span>
                                                    </div>

                                                    <p>
                                                        Type :
                                                        <span class="highlight"> String</span><br/>
                                                        Selected payout institution.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">session_id</span>
                                                    </div>

                                                    <p>
                                                        Type :
                                                        <span class="highlight"> String</span><br/>
                                                        Transaction Session ID.
                                                    </p>

                                                </div>
                                                </div>
                                                <div class="attributes">

                                                    <div class="attributes-head">
                                                    <h4>Dynamic Response Fields</h4>
                                                    </div>

                                                    <div class="attributes-contents">

                                                    <p>

                                                    <b>fieldName</b> :
                                                    <span class="highlight">String</span><br/>

                                                    <b>fieldLabel</b> :
                                                    <span class="highlight">String</span><br/>

                                                    <b>required</b> :
                                                    <span class="highlight">Boolean</span><br/>

                                                    <b>type</b> :
                                                    <span class="highlight">String</span><br/>

                                                    <b>minLength</b> :
                                                    <span class="highlight">Number</span><br/>

                                                    <b>maxLength</b> :
                                                    <span class="highlight">Number</span><br/>

                                                    <b>regex</b> :
                                                    <span class="highlight">String</span><br/>

                                                    <b>dynamicField</b> :
                                                    <span class="highlight">Boolean</span><br/>

                                                    <b>dependsOn</b> :
                                                    <span class="highlight">String</span><br/>

                                                    <b>data</b> :
                                                    <span class="highlight">Array</span>

                                                    </p>

                                                    </div>

                                                    </div>
                                            </div>
                                        </section>


                                    </div>
                                    <div class="col-lg-6 col-12 mr-4">
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">Api Endpoint</p>
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        Method : POST <br />
                                                        &nbsp;Endpoint: /v2/merchant/get-recipient-form
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">PRE-REQUEST API KEY</p>
                                                <svg style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, request_data);
                                                 }}
                                                    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8" />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        {request_data}

                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox copybox-response mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">RESPONSE</p>
                                                <svg 
                                                style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, response_data);
                                                 }} 
                                                 width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8"
                                                    />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code id="copy-txt" class="copybox-code ">
                                                        {response_data}
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                
                            </header>

                        </article>
                        
                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Dynamic Rendering Rules
                                </h2>

                                <ul>
                                    <li>Render every field returned by the API dynamically.</li>

                                    <li>Do not hardcode labels, validation rules, or dropdown values.</li>

                                    <li>
                                        Apply <code>required</code>, <code>minLength</code>,
                                        <code>maxLength</code>, and <code>regex</code> validation from
                                        the API response.
                                    </li>

                                    <li>
                                        Render dropdown values from the <code>data</code> array.
                                    </li>

                                    <li>
                                        If <code>dynamicField = true</code>, display the field only
                                        after its dependency is satisfied.
                                    </li>
                                </ul>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Recipient Validation
                                </h2>

                                <p>
                                    Some payout providers require beneficiary details to be validated
                                    before a payment can be created.
                                </p>

                                <div class="alert alert-info">
                                    <b>When to Validate</b>

                                    <p class="mb-0">
                                        If any field returned by the <code>Get Recipient Form</code> API
                                        contains <code>validateRequired = true</code> and a non-empty
                                        <code>validateEndpoint</code>, you must call the validation API
                                        before calling the <code>Make Payment</code> API.
                                    </p>
                                </div>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Validation Flow
                                </h2>

                                <ol style={{marginLeft: "17px"}}>
                                    <li>Call the <b>Get Recipient Form</b> API.</li>

                                    <li>
                                        Render all returned recipient fields dynamically.
                                    </li>

                                    <li>
                                        Collect all required beneficiary information.
                                    </li>

                                    <li>
                                        Check whether any returned field contains 
                                        <code>validateRequired = true</code>.
                                    </li>

                                    <li>
                                        If validation is required, call the API specified in 
                                        <code>validateEndpoint</code>.
                                    </li>

                                    <li>
                                        If validation succeeds, proceed to 
                                        <b> Make Payment</b>.
                                    </li>

                                    <li>
                                        If validation fails, display the returned error message and
                                        stop the payment flow.
                                    </li>

                                    <li>
                                        If no validation is required, proceed directly to 
                                        <b> Make Payment</b>.
                                    </li>

                                </ol>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Validation Response Fields
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Field</th>
                                            <th>Type</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>validateRequired</td>
                                            <td>Boolean</td>
                                            <td>
                                                Indicates whether recipient validation is required
                                                before payment.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>validateEndpoint</td>
                                            <td>String</td>
                                            <td>
                                                API endpoint that must be called to validate the
                                                recipient details.
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Example Recipient Field
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                                        {validationFieldExample}
                                    </code>
                                </pre>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Example Validation Request (Bank)
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                                        {validationBankRequest}
                                    </code>
                                </pre>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Example Validation Request (Mobile Wallet)
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                                        {validationMobileRequest}
                                    </code>
                                </pre>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Validation Response
                                </h2>

                                <div class="row">

                                    <div class="col-lg-6">

                                        <h5>Success</h5>

                                        <pre>
                                            <code class="copybox-code">
                                                {validationSuccessResponse}
                                            </code>
                                        </pre>

                                    </div>

                                    <div class="col-lg-6">

                                        <h5>Failure</h5>

                                        <pre>
                                            <code class="copybox-code">
                                                {validationFailureResponse}
                                            </code>
                                        </pre>

                                    </div>

                                </div>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Validation Business Rules
                                </h2>

                                <table class="table table-bordered table-white">

                                    <thead>
                                        <tr>
                                            <th>Rule</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>Validation Required</td>
                                            <td>
                                                Check every returned field for
                                                <code>validateRequired</code>.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Validation Endpoint</td>
                                            <td>
                                                Call the endpoint returned in
                                                <code>validateEndpoint</code>.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Dynamic Endpoint</td>
                                            <td>
                                                Do not hardcode the validation endpoint.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Success</td>
                                            <td>
                                                Continue to the <b>Make Payment</b> API only after
                                                successful validation.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Failure</td>
                                            <td>
                                                Display the validation error and prevent payment
                                                submission.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Optional Validation</td>
                                            <td>
                                                Skip validation if no returned field requires it.
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Regex Validation Examples
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                        {example1}
                                    </code>
                                </pre>

                                <pre>
                                    <code class="copybox-code">
                        {example2}
                                    </code>
                                </pre>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Dynamic Field Example
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                        {example3}
                                    </code>
                                </pre>

                                <p>
                                    When <code>dynamicField</code> is <code>true</code>, display the
                                    field only after the dependency condition is met.
                                </p>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Sender Occupation Example
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                        {example4}
                                    </code>
                                </pre>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">Common Response Fields</h2>

                                <table class="table table-bordered table-white">
                                    <thead>
                                        <tr>
                                            <th>Field</th>
                                            <th>Type</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>ReceiverFirstName</td>
                                            <td>String</td>
                                            <td>Beneficiary First Name</td>
                                        </tr>

                                        <tr>
                                            <td>ReceiverLastName</td>
                                            <td>String</td>
                                            <td>Beneficiary Last Name</td>
                                        </tr>

                                        <tr>
                                            <td>receiverEmail</td>
                                            <td>String</td>
                                            <td>Beneficiary Email Address</td>
                                        </tr>

                                        <tr>
                                            <td>receiverContactNumber</td>
                                            <td>String</td>
                                            <td>Beneficiary Mobile Number</td>
                                        </tr>

                                        <tr>
                                            <td>receiverAddress</td>
                                            <td>String</td>
                                            <td>Beneficiary Address</td>
                                        </tr>

                                        <tr>
                                            <td>receiverCity</td>
                                            <td>String</td>
                                            <td>Beneficiary City</td>
                                        </tr>

                                        <tr>
                                            <td>receiverPostalCode</td>
                                            <td>String</td>
                                            <td>Beneficiary Postal Code</td>
                                        </tr>

                                        <tr>
                                            <td>receiverDateOfBirth</td>
                                            <td>String</td>
                                            <td>Beneficiary Date of Birth</td>
                                        </tr>

                                        <tr>
                                            <td>purposeOfPayment</td>
                                            <td>String</td>
                                            <td>Purpose of Transfer</td>
                                        </tr>

                                        <tr>
                                            <td>subPurposeOfPayment</td>
                                            <td>String</td>
                                            <td>Sub Purpose of Transfer</td>
                                        </tr>

                                        <tr>
                                            <td>BankAccountNumber</td>
                                            <td>String</td>
                                            <td>Beneficiary Bank Account Number</td>
                                        </tr>

                                        <tr>
                                            <td>BankBranchCode</td>
                                            <td>String</td>
                                            <td>Bank Branch Code (e.g. IFSC Code)</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">Business Rules</h2>

                                <table class="table table-bordered table-white">

                                <thead>

                                    <tr>
                                        <th>Rule</th>
                                        <th>Description</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Dynamic Rendering</td>
                                        <td>Render all fields returned by the API dynamically.</td>
                                    </tr>

                                    <tr>
                                        <td>Dynamic Validation</td>
                                        <td>Validation must follow the API response.</td>
                                    </tr>

                                    <tr>
                                        <td>No Hardcoding</td>
                                        <td>Do not hardcode beneficiary fields.</td>
                                    </tr>

                                    <tr>
                                        <td>Regex Validation</td>
                                        <td>Apply the regex returned by the API.</td>
                                    </tr>

                                    <tr>
                                        <td>Purpose Of Payment</td>
                                        <td>Dropdown values must come from the API.</td>
                                    </tr>

                                    <tr>
                                        <td>Sub Purpose Of Payment</td>
                                        <td>Display dynamically when applicable.</td>
                                    </tr>

                                    <tr>
                                        <td>Sender Occupation</td>
                                        <td>Display the returned dropdown values and submit the selected value in the Make Payment request.</td>
                                    </tr>

                                </tbody>

                                </table>

                            </section>
                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-get-payout-list"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>
                                                &nbsp;Get Payout List
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-get-branch-codes"
                                            >
                                                Get Branch Codes
                                                &nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}